import config from 'config'
import { authHeader, queryHelper, router } from '../_helpers'

export const testService = {
  sharingUsers,
  testProfile,
  testSummary,
  annotations,
  newAnnotation,
  editAnnotation,
  removeAnnotation,
  tests,
  testData,
  editTestTags,
  userLabel,
  stats
}

function sharingUsers (queryName, label, page) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  var url = `${config.apiUrl}/sharing_user`
  var queryParams = {
    'page_size': 25,
    'page_num': page || 0
  }
  if (queryName && queryName.length > 0) {
    queryParams['name'] = encodeURIComponent(queryName)
  }
  if (label && label.length > 0) {
    queryParams['label'] = encodeURIComponent(label)
  }

  return fetch(queryHelper(url, queryParams), requestOptions).then(handleResponse)
}

function testProfile (userUuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/test_profile/${userUuid}`, requestOptions).then(handleResponse)
}

function testSummary (context, fromDate, patientUuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  var url = `${config.apiUrl}/test_summary`
  var queryParams = {
    'context': context,
    'from_date': fromDate,
    'patient_uuid': patientUuid,
    'test_owner': 1
  }
  return fetch(queryHelper(url, queryParams), requestOptions).then(handleResponse)
}

function annotations (userUuid, fromDate, toDate) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  var url = `${config.apiUrl}/annotation/${userUuid}`
  var hasFrom = false
  if (fromDate && fromDate > 0) {
    hasFrom = true
    url = url.concat(`?from_date=${fromDate}`)
  }
  if (toDate && toDate > 0) {
    if (hasFrom) {
      url = url.concat(`&to_date=${toDate}`)
    } else {
      url = url.concat(`?to_date=${toDate}`)
    }
  }

  return fetch(url, requestOptions).then(handleResponse)
}

function newAnnotation (userUuid, annotation) {
  const requestBody = {
    patient_uuid: userUuid,
    annotation: annotation
  }

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(requestBody)
  }

  return fetch(`${config.apiUrl}/annotation`, requestOptions).then(handleResponse)
}

function editAnnotation (annotationUuid, annotation) {
  const requestBody = {
    annotation: annotation
  }

  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(requestBody)
  }

  return fetch(`${config.apiUrl}/annotation/${annotationUuid}`, requestOptions).then(handleResponse)
}

function removeAnnotation (annotationUuid) {
  const requestOptions = {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  }

  return fetch(`${config.apiUrl}/annotation/${annotationUuid}`, requestOptions).then(handleResponse)
}

function tests (userUuid, fromDate, toDate, type, context) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  var url = `${config.apiUrl}/test?user_uid=${userUuid}&test_owner=1`
  if (fromDate && fromDate > 0) {
    url = url.concat(`&from_date=${fromDate}`)
  }
  if (toDate && toDate > 0) {
    url = url.concat(`&to_date=${toDate}`)
  }
  if (type && type.length > 0) {
    url = url.concat(`&type=${type}`)
  }
  if (context && context.length > 0) {
    url = url.concat(`&context=${context}`)
  }
  if (context === 'daily') {
    url = url.concat(`&with_tags=true`)
    url = url.concat(`&test_order=1`)
  }

  return fetch(url, requestOptions).then(handleResponse)
}

function testData (uuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/test_data/${uuid}`, requestOptions).then(handleResponse)
}

function editTestTags (testUuid, tags) {
  const requestBody = {
    tags: tags
  }

  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(requestBody)
  }

  return fetch(`${config.apiUrl}/test_tags/${testUuid}`, requestOptions).then(handleResponse)
}

function userLabel (userUuid, label) {
  const requestBody = {
    label: label
  }

  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(requestBody)
  }

  return fetch(`${config.apiUrl}/user_label/${userUuid}`, requestOptions).then(handleResponse)
}

function stats (userUuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/user_stats`, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    console.log('handleResponse testS', text)

    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        localStorage.removeItem('user_uuid')
        localStorage.removeItem('tokens')
        if (router.currentRoute.path !== '/login') {
          router.push('/login').catch(() => {})
        }
      }

      const error = {
        status: response.status || (data && data.status) || null,
        error: (data && data.message) || response.statusText
      }
      return Promise.reject(error)
    }

    return data
  })
}



// WEBPACK FOOTER //
// ./src/_services/test.service.js